export function Title({ title }) {
  return (
    <h1 className="flex-[0_0_40px] w-full flex items-center px-5 text-xl font-bold text-white bg-[#6593B5]">
      {title}
    </h1>
  );
}
